import React from "react";

import "antd/dist/antd.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";

const antIcon = (
    <LoadingOutlined
        style={{ fontSize: 30, marginRight: 15, marginBottom: 5 }}
        spin
    />
);

const Loading = (props) => {
    const { t } = props;
    return (
        <div>
            <h3>
                <Spin indicator={antIcon} /> {t("loading")}
            </h3>
        </div>
    );
};

export default withTranslation()(Loading);
